
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { checkStatus, loginService } from "../../services";
import Swal from "sweetalert2";





const storeApi = (set, get) => ({

    status: 'unauthorized',
    usuario: undefined,
    menuData: [],
    token: undefined,




    startLoginUser: async(login) => {
        try {
            const { token, usuario, menu } = await loginService(login);
            set({ status: 'authorized', token, usuario, menuData: menu });
            return true;
        } catch (error) {
            set({status: 'unauthorized', token: undefined, usuario: undefined});
            Swal.fire('Error', error.message, 'error');
            return false;
        }
    },





    startCheckStatus: async() => {
        if( !get().token ){ return get().startLogout() }
        try {
            const { token, usuario, menu } = await checkStatus();
            set({ status: 'authorized', token, usuario, menuData: menu });
        } catch (error) {
            set({status: 'unauthorized', token: undefined, usuario: undefined});
        }
    },




    startLogout: () => {
        set({status: 'unauthorized', token: undefined, usuario: undefined});
    },



});




export const useAuthStore = create(
    devtools(
        persist(
            storeApi,
            { name: 'auth-storage' }
        )
    )
)
